import { Skeleton, Stack } from "@altimateai/lego";

const DatabricksCostTotalsTileSkeleton = () => (
  <div className="al-w-60 al-bg-gray-50 al-p-4 al-rounded-xl">
    <Stack direction="column" gap="md">
      <Skeleton className="al-h-6 al-w-full" />
      <Skeleton className="al-h-4 al-w-1/2" />
      <Stack direction="column" gap="sm" className="al-mt-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="al-rounded-lg al-bg-white al-border al-border-gray-200 al-p-3">
            <Stack direction="column" gap="sm">
              <Skeleton className="al-h-3 al-w-3/4" />
              <Skeleton className="al-h-5 al-w-1/2" />
            </Stack>
          </div>
        ))}
      </Stack>
    </Stack>
  </div>
);

export default DatabricksCostTotalsTileSkeleton;
